import { Vector3 } from '@babylonjs/core/Maths/math.vector';

import { toast } from 'react-toastify';
import { _contentsManager, _environment, _system } from '~/Services/Studio/studioScene';
import {
    ContentEvent, contentObservable, getLights, getModels
} from '../Contents';
import { ContentModel } from '~/Scene/Content/contentModel';
import { ContentLight } from '~/Scene/Content/contentLight';
import { ContentAnimation } from '~/Scene/Content/contentAnimation';
import { IContentOptions } from '~/Scene/Content/content';
import { isRightModelExtension } from '~/Scene/Tool/toolLoader';

const CONTENTS_TYPE = ['model', 'light'];

export const addContent = (
    content: IContentOptions, typedata: any
): ContentAnimation | ContentLight | ContentModel => {
    const { type, tag } = content;
    if (CONTENTS_TYPE.indexOf(type) === -1) return null;
    if (!tag) {
        if (type === 'light') {
            const nbLights = getLights().length + 1;
            const tag = `${type} ${nbLights.toString()}`;
            console.warn('Adding random id to light');
            content.id = tag;
            content.tag = tag;
        }
        if (type === 'model') {
            const nbModels = getModels().length + 1;
            const tag = `${type} ${nbModels.toString()}`;
            content.tag = tag;
            content.id = tag;
        }
    }
    return _contentsManager.addNewContent(content.type, content, typedata);
};

const setStudioGeometry = (model: ContentModel) => {
    const scale = _system.visibleWorld / 10;
    model.setScale(new Vector3(scale, scale, scale));
    model.setPosition(new Vector3(0, scale / 2, 0));
    model.setRotation(new Vector3(0, 0, 0));
};

export const loadModel = (url: string): ContentModel => {
    if (!isRightModelExtension(url)) {
        toast.error('Naker only accept GLTF or GLB file for models');
        return null;
    }
    const model = addContent({
        type: 'model', scale: Vector3.One(), rotation: Vector3.Zero(), position: Vector3.Zero()
    }, {}) as ContentModel;
    model.loadModel(url, () => {
        setStudioGeometry(model);
        model.show();
        _environment.resetShadowGroundHeight();
        contentObservable.notify(ContentEvent.UploadEnd, 100);
    });
    return model;
};
